import { render, staticRenderFns } from "./viewTestPaper.vue?vue&type=template&id=2643343e&scoped=true&"
import script from "./viewTestPaper.vue?vue&type=script&lang=js&"
export * from "./viewTestPaper.vue?vue&type=script&lang=js&"
import style0 from "./viewTestPaper.vue?vue&type=style&index=0&id=2643343e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2643343e",
  null
  
)

export default component.exports